import React from 'react';
import { useTranslation } from 'react-i18next';
import KanbanColumn from './KanbanColumn';

export default function KanbanBoard({
  columns = [],
  onMove,
  onPatch,
  onCardClick,
  typeCard,
}) {
  const { t: translate } = useTranslation();
  const handleMoveCard = React.useCallback(
    (card, fromColId, toColId, _toIdx, meta = {}) => {
      const { beforeId = null, afterId = null } = meta;
      onMove({
        card,
        fromColId,
        toColId,
        beforeId,
        afterId,
      });
    },
    [onMove],
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'stretch',
        backgroundColor: '#ffffff',
        boxSizing: 'border-box',
        gap: 12,
      }}
    >
      {columns.length > 0 ? (
        columns.map(col => (
          <KanbanColumn
            key={col.id}
            column={col}
            onMoveCardIdBased={handleMoveCard}
            onPatch={onPatch}
            onCardClick={onCardClick}
            typeCard={typeCard}
          />
        ))
      ) : (
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#888',
            fontStyle: 'italic',
            minHeight: '100%',
          }}
        >
          {translate('common:NoColumnsAvailable')}
        </div>
      )}
    </div>
  );
}
